import React, { useState } from 'react';
import { TextField, Button, Box, Typography, Grid, FormHelperText } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import InfoIcon from '@mui/icons-material/Info';

function PaperUrlInput({ onSearch, loading }) {
  const [paperUrl, setPaperUrl] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (paperUrl.trim()) {
      onSearch(paperUrl);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mb: 3 }}>
      <Typography variant="h6" component="h3" gutterBottom>
        Add a paper directly by URL
      </Typography>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={9}>
          <TextField
            fullWidth
            label="Enter Paper URL"
            value={paperUrl}
            onChange={(e) => setPaperUrl(e.target.value)}
            placeholder="https://arxiv.org/abs/2201.12345"
            variant="outlined"
            disabled={loading}
          />
          <FormHelperText sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
            <InfoIcon fontSize="small" color="info" />
            The source paper will be automatically added to your selection (note: arXiv links only for now)
          </FormHelperText>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Button
            fullWidth
            type="submit"
            variant="contained"
            color="primary"
            startIcon={<SearchIcon />}
            disabled={!paperUrl.trim() || loading}
          >
            Add Paper
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default PaperUrlInput; 